
import { TimeIntervalEnum } from "../enums/timeIntervalEnum";
import { PeriodPartSelectionEnum } from "../enums/periodPartSelectionEnum";

import * as appsettings from "../appsettings";
import * as main from "../main";
import * as timeinterval from "../timeinterval";
import * as moment from "moment";



let dateTimeErrorMessageLabel = "";

/*
* Show / Hide Period Selector
**/
function setVisibilityPeriodSelector(): void {
    const timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

    if (timeinterval_value == TimeIntervalEnum.AskedPeriod) {
        $("#periodSelector").show();
    } else {
        $("#periodSelector").hide();
    }
}


/**
* Initialize
*/
export function initialize(dateTimeErrorMessage: string): void {
    dateTimeErrorMessageLabel = dateTimeErrorMessage;

    main.setHideDiv("errorMessage", false);
    $("#ReportSearchButtonLoader").hide();
    $("#ReportExportButtonLoader").hide();

    setVisibilityPeriodSelector();
    this.searchAction(null);
}

/**
* onChange for TimeInterval (show / hide periodSelector)
*/
export function onChangeTimeInterval(): void {
    setVisibilityPeriodSelector();
}

/**
* Action export (will download excel document according to the selected period)
*/
export function exportAction(e: kendo.ui.ButtonClickEvent): void {
    //stop the browser from following
    e.preventDefault();

    main.setHideDiv("errorMessage", false);

    // Show the waiting indicator
    $("#ReportExportButtonLoader").show();

    // get preference / options selected
    const selectedGroupId = Number($("#GroupId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());
    const selectedPeriod = Number($("#PeriodPartSelection").data("kendoDropDownList").value());

    // Get selection period
    let from: string = "";
    let fromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (fromDt != null) {
        from = moment(fromDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    let to: string = "";
    let toDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (toDt != null) {
        to = moment(toDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    if (from != "" && to != "") {
        // Download File
        $.fileDownload(appsettings.getLocalUrl('Report/Export?groupId=' + selectedGroupId + "&from=" + from + "&to=" + to + "&workingDay=" + selectedPeriod))
            .done(function () { $("#ReportExportButtonLoader").hide(); })
            .fail(function () { $("#ReportExportButtonLoader").hide(); });
    }
    else {
        // Hide Indicator
        $("#ReportExportButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        var lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* Action search (will display certain bar charts according to the selected period)
*/
export function searchAction(): void {
    // Indicator
    $("#ReportSearchButtonLoader").show();

    main.setHideDiv("errorMessage", false);

    // get preference / options selected
    const selectedGroupId = Number($("#GroupId").data("kendoDropDownList").value());
    const selectedInterval = Number($("#TimeInterval").data("kendoDropDownList").value());
    const selectedPeriod = Number($("#PeriodPartSelection").data("kendoDropDownList").value());

    // Get selection period
    let From: string = "";
    let FromDt = timeinterval.getBeginPeriodSelection(selectedInterval, "From");
    if (FromDt != null) {
        From = moment(FromDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    let To: string = "";
    let ToDt = timeinterval.getEndPeriodSelection(selectedInterval, "To");
    if (ToDt != null) {
        To = moment(ToDt.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
    }

    if (From != null && To != null) {
        // Do request
        $.ajax({
            type: "GET",
            dataType: "html",
            url: appsettings.getUrl("Report/Search"),
            data: {
                GroupId: selectedGroupId,
                From: From,
                To: To,
                WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
            },
            success: function (responseData: string) {
                // Get response
                $("#searchResult").html(responseData);

                // Hide Indicator
                $("#ReportSearchButtonLoader").hide();
            }
        });
    }
    else {
        // Hide Indicator
        $("#ReportSearchButtonLoader").hide();

        // make a message
        main.setHideDiv("errorMessage", true);

        var lblError = $("#errorMessageLabel");
        if (lblError != null && lblError != undefined) {
            lblError.text(dateTimeErrorMessageLabel);
        }
    }
}

/**
* start / from 
*/
export function fromChange(): void {
    const start = $("#From").data("kendoDatePicker");
    const end = $("#To").data("kendoDatePicker");
    let startDate = start.value();
    let endDate = end.value();

    if (startDate) {
        startDate = new Date(startDate);
        startDate.setDate(startDate.getDate());
        end.min(startDate);
    } else if (endDate) {
        start.max(new Date(endDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}

/**
* end / to
*/
export function toChange(): void {
    const start = $("#From").data("kendoDatePicker");
    const end = $("#To").data("kendoDatePicker");
    let endDate = end.value();
    let startDate = start.value();

    if (endDate) {
        endDate = new Date(endDate);
        endDate.setDate(endDate.getDate());
        start.max(endDate);
    } else if (startDate) {
        end.min(new Date(startDate));
    } else {
        endDate = new Date();
        start.max(endDate);
        end.min(endDate);
    }
}
